/**
 * Comunicação com o app nativo (nexus-motorista-native) via deep link.
 * O app nativo mantém o rastreamento com a tela desligada ou minimizado.
 */

const NATIVE_APP_SCHEME = 'nexusmotorista';

/** Tempo para o sistema trocar para o app nativo antes de considerarmos que ele não abriu. */
const TEMPO_DETECCAO_MS = 2500;

export interface NativeAppTrackingParams {
  osId: number;
  faseId: number;
  token: string;
  action: 'start' | 'stop';
}

const buildDeepLink = ({ osId, faseId, token, action }: NativeAppTrackingParams): string =>
  `${NATIVE_APP_SCHEME}://track?osId=${osId}&faseId=${faseId}&token=${encodeURIComponent(token)}&action=${action}`;

/**
 * Dispara o deep link. Deve ser chamado diretamente no clique do usuário:
 * o navegador bloqueia a abertura de outro app sem um gesto recente.
 */
export const openNativeApp = (params: NativeAppTrackingParams): void => {
  try {
    window.location.href = buildDeepLink(params);
  } catch (error) {
    console.error('Erro ao abrir app nativo:', error);
  }
};

/**
 * Abre o app nativo e resolve `true` se a página saiu de foco (o app abriu)
 * ou `false` se continuou visível (app não instalado ou bloqueado).
 */
export const abrirAppNativoComDeteccao = (
  params: NativeAppTrackingParams
): Promise<boolean> =>
  new Promise((resolve) => {
    let finalizado = false;

    const finalizar = (abriu: boolean) => {
      if (finalizado) return;
      finalizado = true;
      document.removeEventListener('visibilitychange', aoMudarVisibilidade);
      window.removeEventListener('pagehide', aoOcultarPagina);
      window.clearTimeout(timer);
      resolve(abriu);
    };

    const aoMudarVisibilidade = () => {
      if (document.hidden) finalizar(true);
    };
    const aoOcultarPagina = () => finalizar(true);

    document.addEventListener('visibilitychange', aoMudarVisibilidade);
    window.addEventListener('pagehide', aoOcultarPagina);
    const timer = window.setTimeout(() => finalizar(document.hidden), TEMPO_DETECCAO_MS);

    openNativeApp(params);
  });
